import { useEffect } from 'react';
import PropTypes from 'prop-types';
import SideMenu from '../../Common/Menus/SideMenu.jsx';

/**
 * Shared container for every AI assistant surface.
 *
 * Feature-specific assistants own their workflow and content, while this
 * component keeps menu presentation and close behaviour consistent.
 */
const AiAssistantMenuShell = ({
  expanded,
  onClose,
  busy = false,
  title = 'AI Assistant',
  iconClass = 'bi-stars',
  className = '',
  animate = true,
  closeOnEscape = true,
  children,
}) => {
  useEffect(() => {
    if (!expanded || !closeOnEscape) return undefined;
    const handleEscape = (event) => {
      if (event.key === 'Escape' && !busy) onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [busy, closeOnEscape, expanded, onClose]);

  return (
    <SideMenu
      side="right"
      title={title}
      iconClass={iconClass}
      className={className}
      expanded={expanded}
      setExpanded={(value) => {
        if (!value) onClose();
      }}
      animate={animate}
    >
      {children}
    </SideMenu>
  );
};

AiAssistantMenuShell.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  busy: PropTypes.bool,
  title: PropTypes.string,
  iconClass: PropTypes.string,
  className: PropTypes.string,
  animate: PropTypes.bool,
  closeOnEscape: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default AiAssistantMenuShell;
